import { Component, OnInit, Input } from '@angular/core';
import { ManagedClient } from '../../shared/models/managed-client';
import { Assignment } from '../../shared/models/Assignment';
import { AssessmentGroup } from 'app/shared/models/assessment-group';
import { ClientService } from '../../shared/services/client.service';
import { Assessment } from "../../shared/models/assessment";
import { Location } from "@angular/common";
import { DacConfig } from "../../shared/services/dac-config.service";
import { AssessmentTokenService } from "../../shared/services/assessment-token.service";
import { ReportService } from "../../reports/services/report.service";
import { AlertService } from 'app/shared/services/alert.service';
import { ShoppingService } from 'app/shared/services/shopping.service';
import { AssessmentAssignerService } from '../services/assessment-assigner.service';
import { AssignmentService } from 'app/shared/services/assignment.service';
import { LibraryAsset } from 'app/library-assets/models/library-asset';
import { AssignmentSingle } from 'app/shared/models/AssignmentSingle';
import { AssignedLibraryAsset } from 'app/shared/models/AssignedLibraryAsset';

@Component({
  selector: 'dac-client-manage-assignments',
  templateUrl: './client-manage-assignments.component.html',
  styleUrls: ['./client-manage-assignments.component.scss']
})
export class ClientManageAssignmentsComponent implements OnInit {

  @Input() client:ManagedClient;
  
  constructor(private _clientService: ClientService,
    private location: Location,
    private alertService: AlertService,
    private dacConfig:DacConfig,
    private assessmentTokenService:AssessmentTokenService,
    private reportService:ReportService,
    private shoppingService:ShoppingService,
    private assessmentAssignerService:AssessmentAssignerService,
    private assignmentService:AssignmentService
    ) { }

  ngOnInit() {
  }

  public get assignments(): Assignment[] {
    return this.client.assignments;
  }

  public addAssessmentsFromBattery(group:AssessmentGroup) {
    this.assessmentAssignerService.addAssessmentsFromBattery(this.client, group);
  }

  public addAssessment(assessment: Assessment) {
    this.assessmentAssignerService.addAssessment(this.client, assessment);
  }
  
  public clearAssignment(assignment: Assignment) {
    if (assignment.Type != "LibraryAsset") {
      this.assessmentAssignerService.removeAssessment(this.client, assignment);
    }
    else {
      this.assignmentService.removeClientAssignment(this.client, assignment).then(() => {
        this.client.removeAssignment(assignment);
        this._clientService.syncLocalClient(this.client);
        this.alertService.success("Assignment removed");
      })
      .catch((error) => {
        console.error(error);
        this.alertService.error("Failed to remove assignment", 1500);
      });
       
    }
  }

  public addAssetAssignment(asset:LibraryAsset) {

    if (!asset) {
      console.error("asset was null.  Cannot add");
      return;
    }

    // TODO: stephen this needs to be switched to be the
    // assessments.
    // var assignment = {
    //   assetId: asset.id
    //   ,name: asset.title
    //   ,dateAssigned: new Date()
    // };
    let assignment = new AssignmentSingle();
    assignment.Type = "LibraryAsset";
    assignment.DateAssigned = new Date();
    let assignmentItem = new AssignedLibraryAsset();
    assignmentItem.Name = asset.title;
    assignmentItem.Type = "LibraryAsset";
    assignmentItem.AssetId = asset.id;
    assignment.Items.push(assignmentItem);
    
    let alertId = this.alertService.info("Adding " + assignment.Name + " to " + this.client.id, 120000);
    this.assignmentService.saveClientAssignment(this.client, assignment)
      .then((assignment:Assignment) => {
        this.client.assignments.push(assignment);
        this._clientService.syncLocalClient(this.client);
        this.alertService.clearAlert(alertId);
        this.alertService.success("Added " + assignment.Name + " to " + this.client.id);
      })
      .catch((error) => {
        this.alertService.clearAlert(alertId);
        this.alertService.error("There was an error in adding this item to the client.  Please try again or contact customer support");
        console.error(error);
      });
      
  }

  handleBatteryCheckout(group:AssessmentGroup) {
    let checkoutSubscription = null;
    let assignerService = this.assessmentAssignerService;
    let tokenService = this.assessmentTokenService;
    let client = this.client;

    checkoutSubscription = this.shoppingService.getCheckoutStatus().subscribe((status) => {
      if (checkoutSubscription && (status == "ORDER_COMPLETE" || status == "ORDER_CANCELLED")) {
        checkoutSubscription.unsubscribe();
      }

      if (status == "ORDER_COMPLETE") {
        // we will refresh this when we the user's get back to the screen, but we need to add it at the time of purchase
        tokenService.addTokensForGroup(group, 1);
        assignerService.addAssessmentsFromBattery(client, group);
      }
    });
  }

  handleAssessmentCheckout(assessment:Assessment  ) {
    let checkoutSubscription = null;
    let assignerService = this.assessmentAssignerService;
    let tokenService = this.assessmentTokenService;
    let client = this.client;

    checkoutSubscription = this.shoppingService.getCheckoutStatus().subscribe((status) => {
      if (checkoutSubscription && (status == "ORDER_COMPLETE" || status == "ORDER_CANCELLED")) {
        checkoutSubscription.unsubscribe();
      }

      if (status == "ORDER_COMPLETE") {
        // we will refresh this when we the user's get back to the screen, but we need to add it at the time of purchase
        tokenService.addTokens(assessment, 1);
        assignerService.addAssessment(client, assessment);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/client-manage-assignments/client-manage-assignments.component.ts